import React from 'react';
import DOMPurify from 'dompurify';

const SanitizedHTML = ({ html }) => (
  <span className="sanitized-html" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
);

export default SanitizedHTML;
